import { useCallback } from 'react';
import {
  IS_FEATURE_FLAG_ACTIVE,
  IsFeatureFlagActiveResponse,
} from '../../configs/APISchemas/isFeatureFlagActiveGraphQL';
import { FeatureFlag } from '../../constants/feature-flag';
import { GraphQLRequest } from '../GraphQLRequest';

const useGetFeatureFlag = () => {
  const getFeatureFlag = useCallback(
    async (name: FeatureFlag): Promise<boolean> => {
      const query = IS_FEATURE_FLAG_ACTIVE(name);
      const response = await GraphQLRequest<IsFeatureFlagActiveResponse>(query);
      return response?.isFeatureActive?.enabled;
    },
    [],
  );

  return { getFeatureFlag };
};

export default useGetFeatureFlag;
